import { Modal, Button, typography } from '@ui';

type ConfirmDeleteThreadModalProps = {
    onDismiss: () => void;
    onSubmit: () => void;
};

export const ConfirmDeleteThreadModal = ({ onDismiss, onSubmit }: ConfirmDeleteThreadModalProps) => {
    return (
        <Modal
            variant="partial"
            title="Delete Thread"
            onDismiss={onDismiss}
            open
            footer={{
                primary: (
                    <Button variant="destroy" onClick={onSubmit}>
                        Delete
                    </Button>
                ),
                secondary: (
                    <Button variant="secondary" onClick={onDismiss}>
                        Cancel
                    </Button>
                ),
            }}
        >
            <p className={typography({ variant: 'p' })} style={{ maxWidth: 600 }}>
                Are you sure you want to delete thread?
            </p>
        </Modal>
    );
};
